import { media } from "../config/media";
import { Image } from "./Image";
import { type ViewProps, XStack } from "./Stacks";
export type BackgroundRadialGrantedGradientProps = ViewProps & {
  fullscreen?: boolean;
  objectFit?: "cover" | "fill";
};
const GT_SM_MEDIA_QUERY = `(min-width: ${media.gtSm.minWidth}px)`;
export const BackgroundRadialGrantedGradient = (props: BackgroundRadialGrantedGradientProps) => {
  const {
    fullscreen = true,
    objectFit,
    ...rest
  } = props;
  return <XStack top={0} left={0} right={0} position="absolute" width="100%" height="100%" overflow="hidden" zIndex={0} backgroundColor={fullscreen ? "$surface1" : undefined} {...rest} data-sentry-element="XStack" data-sentry-component="BackgroundRadialGrantedGradient" data-sentry-source-file="BackgroundRadialGrantedGradient.tsx">
      {fullscreen ? <picture>
          <source media={GT_SM_MEDIA_QUERY} srcSet="/static/backgroundGradientFullscreen.webp" />
          <Image src="/static/backgroundGradientFullscreenPortrait.webp" position="absolute" top={0} left={0} right={0} bottom={0} width="100%" height="100%" objectFit={objectFit ?? "fill"} $gtSm={{
        bottom: "auto",
        height: "auto",
        maxWidth: 1200,
        marginHorizontal: "auto",
        objectFit: objectFit === "fill" ? "fill" : "contain"
      }} />
        </picture> : <Image src="/static/backgroundGradient.png" height="100%" width="100%" objectFit={objectFit ?? "cover"} style={{
      opacity: 1,
      position: "absolute",
      top: 0,
      left: 0,
      right: 0,
      bottom: 0
    }} />}
    </XStack>;
};